import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import '@fortawesome/fontawesome-free/css/all.min.css';
import { ToastContainer } from "react-toastify";
import AboutUs from "./pages/AboutUs";
import Properties from "./pages/Properties";
import Projects from "./pages/Projects";
import Blogs from "./pages/Blogs";
import Login from "./pages/Login";
import SignUp from "./pages/SignUp";
import Profile from "./pages/Profile";
import PropertyDetails from "./pages/PropertyDetails";
import ContactUs from "./pages/ContactUs";
import Blogdetails from "./pages/Blogdetails";
import Termsandcondition from "./pages/Termsandcondition";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import { CategoryProvider } from "./Components/CategoryProvider";
import AddProperty from "./pages/AddProperty";


function App() {
  return (
    <>
      <CategoryProvider>
        <ToastContainer />
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/Login" element={<Login />} />
            <Route path="/SignUp" element={<SignUp />} />
            <Route path="/AboutUs" element={<AboutUs />} />
            <Route path="/Properties" element={<Properties />} />
            <Route path="/PropertyDetails/:id" element={<PropertyDetails />} />
            <Route path="/Projects" element={<Projects />} />
            <Route path="/Blogs" element={<Blogs />} />
            <Route path="/BlogDetails/:id" element={<Blogdetails />} />
            <Route path="/Profile" element={<Profile />} />
            <Route path="/ContactUs" element={<ContactUs />} />
            <Route path="/Termsandcondition" element={<Termsandcondition />} />
            <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
            <Route path="/AddProperty" element={<AddProperty />} />
          </Routes>
        </Router>
      </CategoryProvider>
    </>
  );
}

export default App;
